import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';

export const templateTacticsAndTechniques = document.createElement('template');

templateTacticsAndTechniques.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <gz-title id="title" fontWeight="500" fontSize="16"></gz-title>
    <div id="tactics"></div>
  </div>
`;
